import type { IconProps } from './types/types';
import IconWrapper from './wrapper/SvgIconWrapper';

const CheckSquareInsideIcon = (props: IconProps) => {
  return (
    <IconWrapper {...props}>
      <path d="M6.75308 10.2766C6.79907 10.3408 6.8597 10.3931 6.92994 10.4291C7.00019 10.4652 7.07802 10.4841 7.15698 10.4841C7.23595 10.4841 7.31378 10.4652 7.38403 10.4291C7.45427 10.3931 7.5149 10.3408 7.56089 10.2766L10.8515 5.71406C10.9109 5.63125 10.8515 5.51562 10.75 5.51562H10.0171C9.8562 5.51562 9.7062 5.59375 9.61245 5.72344L7.1562 9.12969L6.0437 7.58594C5.94995 7.45469 5.79839 7.37813 5.63902 7.37813H4.9062C4.80464 7.37813 4.74527 7.49375 4.80464 7.57656L6.75308 10.2766Z" />
    </IconWrapper>
  );
};

export default CheckSquareInsideIcon;
